// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"Y8-z","button":"Z8-z","disabled":"_8-z","creditCard":"a9-z","wrapper":"b9-z"};